<template>
  <v-content>
    <div id="app">
      <v-app id="inspire">
        <v-row class="justify-center mt-12">
          <v-dialog v-model="dialog" scrollable max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">Change location</v-btn>
            </template>
            <v-card class="mx-auto">
              <v-container grid-list-xl>
                <v-card-title primary-title class="justify-center">
                  <h2>Locations</h2>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-col>
                    <v-text-field
                      v-model="searchFieldValue"
                      @input="searchSuggestion"
                      label="Search locations"
                      append-icon="place"
                    ></v-text-field>
                    <v-list>
                      <v-list-item
                        v-for="loc in resultJSON"
                        :key="loc.id"
                        @click="selectLocation(loc.id)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ loc.Path }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text>
                  <p>Current location: {{ currentLocation.Label }}</p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-title>
                  <h3>Recent locations</h3>
                </v-card-title>
                <v-card-actions>
                  <v-chip
                    v-for="item in recentLocations"
                    :key="item.id"
                    class="ma-2"
                    color="red"
                    label
                    text-color="white"
                    @click="selectLocation(item.id)"
                  >
                    <v-icon left>place</v-icon>
                    {{ item.location }}
                  </v-chip>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                  <v-btn color="blue darken-1" text @click="dialog = false">Save</v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
        </v-row>
      </v-app>
    </div>
  </v-content>
</template>


<script>
export default {
  data() {
    return {
      dialogm1: "",
      dialog: false,
      searchFieldValue: "",
      resultJSON: null,
      recentLocations: [
        { location: "Steinkjer", id: 4 },
        { location: "Verdal", id: 443 },
        { location: "Bergen", id: 213 },
        { location: "Oppland", id: 903 },
      ],
      currentLocation: {
        id: "none",
        Label: "Worldwide",
        Lft: 1,
        Rgt: 100000,
        catId: "none",
      },
    };
  },
  methods: {
    searchSuggestion() {
      if (this.searchFieldValue.length > 1) {
        this.axios
          .get("/geo/suggestion?name=" + this.searchFieldValue)
          .then((res) => {
            var paths = [];
            if (res.data.length > 0) {
              res.data.forEach(function (element) {
                if (element.Path) {
                  var path =
                    element.Label + ", " + element.Path.split(" / ").join(", ");
                  element.Path = path;
                  paths.push(element);
                } else {
                  paths.push(element.Label);
                }
              });
              this.resultJSON = paths;
            } else {
              this.resultJSON = null;
            }
          })
          .catch((ex) => {
            console.log("ex", ex);
          });
      } else {
        this.resultJSON = null;
      }
    },
    selectLocation(id) {
      // console.log(id);
      this.axios
        .get("/geo/id?id=" + id)
        .then((res) => {
          this.currentLocation = res.data;
        })
        .catch((ex) => {
          console.log("ex", ex);
        });
    },
  },
};
</script>